module.exports = __webpack_public_path__ + "img/2.d11a6387.png";